import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import VersionSelect from 'component/mobileUpdate/VersionSelect'
import MissionSelect from 'component/mobileUpdate/MissionSelect'
import MobileUpdateModal from 'component/mobileUpdate/MobileUpdateModal'
import CompanySelect from 'component/branch/CompanySelect'

const SAVE = 'MOBILE_UPDATE_SAVE'

class MobileUpdateEditForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      modal: false,
      dsBranch: '',
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.beforeSubmit = this.beforeSubmit.bind(this)
    this.clearFields = this.clearFields.bind(this)
    this.renderModal = this.renderModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.openModal = this.openModal.bind(this)
    this.handleChangeLdap = this.handleChangeLdap.bind(this)
  }

  closeModal() {
    this.setState({ modal: false })
  }

  openModal() {
    this.setState({ modal: true })
    this.beforeSubmit()
  }

  renderModal() {
    const { modal } = this.state
    const { translate } = this.props

    if (!modal) {
      return
    }

    const props = {
      translate,
      modalType: SAVE,
      closeModal: this.closeModal,
      onSubmit: this.handleSubmit,
    }

    return <MobileUpdateModal {...props} />
  }

  beforeSubmit() {
    const { values } = this.props
    const { dsBranch } = this.state

    if (values.idBranch) {
      values.dsBranch = dsBranch
    }
    // Sets to 'not updated'
    values.inUpdate = 0
  }

  handleSubmit(event) {
    event.preventDefault()

    const { values, onSubmit } = this.props

    onSubmit(values)

    this.clearFields()
    this.closeModal()
  }

  clearFields() {
    const { invertStates, values } = this.props
    const field = this.props.fields

    field.idBranch.input.value = ''
    field.dsBranch.input.value = ''
    field.cdMission.input.value = ''
    field.idVersion.input.value = ''
    field.dsLdap.input.value = ''

    field.idBranch.error = ''
    field.dsBranch.error = ''
    field.cdMission.error = ''
    field.idVersion.error = ''
    field.dsLdap.error = ''

    values.idBranch = ''
    values.dsBranch = ''
    values.cdMission = ''
    values.idVersion = ''
    values.dsLdap = ''

    this.setState({ dsBranch: '' })

    invertStates()
  }

  handleChangeBranch = (event) => {
    const { values } = this.props
    const field = this.props.fields
    field.dsLdap.input.value = ''
    values.dsLdap = ''
    field.idBranch.input.onChange(event)

    // Gets text from select
    const dsbranch = event.target.options[event.target.selectedIndex].text
    this.setState({ dsBranch: dsbranch })
  }

  handleChangeMission = (event) => {
    const { values } = this.props
    const field = this.props.fields

    field.dsLdap.input.value = ''
    values.dsLdap = ''
    field.cdMission.input.onChange(event)
  }

  handleChangeVersion = (event) => {
    const field = this.props.fields
    field.idVersion.input.onChange(event)
  }

  handleChangeLdap() {
    const field = this.props.fields
    const { values } = this.props

    field.idBranch.input.value = ''
    field.dsBranch.input.value = ''
    field.cdMission.input.value = ''
    values.idBranch = ''
    values.dsBranch = ''
    values.cdMission = ''
  }

  render() {
    const {
      translate,
      auth: { user },
    } = this.props

    const field = this.props.fields

    return (
      <form className='MenuMissionEditForm'>
        <fieldset>
          <Row>
            <Col xs={12} md={12}>
              <Field
                {...field.idBranch}
                error={translate(field.idBranch.error)}
                hint={translate('ruptures.idBranch')}
              >
                <CompanySelect
                  {...field.idBranch.input}
                  onChange={this.handleChangeBranch}
                  excludeInactive={true}
                />
              </Field>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={12}>
              <Field
                {...field.cdMission}
                error={translate(field.cdMission.error)}
                hint={translate('mission-edit.choose-mission')}
              >
                <MissionSelect
                  {...field.cdMission.input}
                  placeholder={translate('mission-edit.choose-mission')}
                  onChange={this.handleChangeMission}
                  user={user}
                  translate={translate}
                />
              </Field>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={12}>
              <Field
                {...field.dsLdap}
                error={translate(field.dsLdap.error)}
                hint={translate('mobile-update.dsLdap-info')}
              >
                <Input
                  id='dsLdap'
                  onKeyPress={this.handleChangeLdap}
                  {...field.dsLdap.input}
                  label={translate('mobile-update.dsLdap')}
                />
              </Field>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={12}>
              <Field
                {...field.idVersion}
                error={translate(field.idVersion.error)}
                hint={translate('mobile-update.version-info')}
              >
                <VersionSelect
                  {...field.idVersion.input}
                  placeholder={translate('version.choose-version')}
                  onChange={this.handleChangeVersion}
                  user={user}
                  translate={translate}
                />
              </Field>
            </Col>
          </Row>
        </fieldset>

        <Row className='margin-top-double margin-bottom'>
          <Col xs={6} md={6}>
            <button
              role='button'
              type='button'
              onClick={this.clearFields}
              className='button-hollow button-hollow-danger button-full align-center'
            >
              {translate('cancel_button_label')}
            </button>
          </Col>

          <Col xs={6} md={6}>
            <button
              role='button'
              type='button'
              onClick={this.openModal}
              className='button button-primary button-full'
            >
              {translate('save_button_label')}
            </button>
          </Col>
        </Row>

        {this.renderModal()}
      </form>
    )
  }
}

MobileUpdateEditForm.propTypes = {
  fields: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  invertStates: PropTypes.func.isRequired,
}

const fields = [
  'idBranch',
  'dsBranch',
  'cdMission',
  'idVersion',
  'dsLdap',
  'inUpdate',
]

export default Form({ fields })(MobileUpdateEditForm)

export { MobileUpdateEditForm }
